import { createSlice } from "@reduxjs/toolkit";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  ShowMessage: false,
  Message: "",
  Style: Style.Success,
};

export const signalRAlertSlice = createSlice({
  name: "signalRAlert",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.Message = action.payload;
    },
    setStyle: (state, action) => {
      state.Style = action.payload;
    },
    setShowMessage: (state, action) => {
      state.ShowMessage = action.payload;
    },
  },
});

export const { setStyle, setMessage, setShowMessage } = signalRAlertSlice.actions;

export const selectMessage = (state: RootState) => state.signalRAlerts.Message;
export const selectStyle = (state: RootState) => state.signalRAlerts.Style;
export const selectShowMessage = (state: RootState) => state.signalRAlerts.ShowMessage;

export default signalRAlertSlice.reducer;
